module.exports = __webpack_public_path__ + "static/img/empty-record.5f1e716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/empty-record.png
// module id = NEkj
// module chunks = 0